/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ player: NonNullable<unknown> }} Err_Tournament_Self_Organize_IneligibleInputs */



/**
* | output |
* | --- |
* | "Player {player} is already playing or done and cannot be seated" |
*
* @param {Err_Tournament_Self_Organize_IneligibleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_self_organize_ineligible = /** @type {((inputs: Err_Tournament_Self_Organize_IneligibleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Self_Organize_IneligibleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le joueur ${i?.player} est déjà en train de jouer ou a terminé et ne peut pas être placé`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El jugador ${i?.player} ya está jugando o ha finalizado y no puede ser sentado`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`O jogador ${i?.player} já está jogando ou terminou e não pode ser alocado`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il giocatore ${i?.player} sta già giocando o ha terminato e non può essere seduto`)
	return /** @type {LocalizedString} */ (`Player ${i?.player} is already playing or done and cannot be seated`)
});